export default __webpack_public_path__ + "static/media/red-mountain-2.b125a72f.PNG";